import { ReactNode } from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { SearchMaterialChemistry } from "contexts/search/context";
import { useTenantTranslation } from "hooks/formatters";
import { useFormatNumber } from "src/utils/formatNumber";
import { MarkerDot } from "components/defaultParameters/MarkerDot";
import { MaterialOverrideRow } from "./types";

export const ChemistryMeasurementCell = ({
  row,
  field,
  materialChemistry,
  scrapchefChemistry,
  warning,
}: {
  row: MaterialOverrideRow;
  field: "loc" | "scale";
  materialChemistry: SearchMaterialChemistry;
  scrapchefChemistry: SearchMaterialChemistry | undefined;
  warning?: ReactNode;
}) => {
  const { t } = useTenantTranslation();
  const formatNumber = useFormatNumber()(4);
  const original =
    materialChemistry[row.material_id]?.[row.chemical_element_id];
  const scrapchef =
    scrapchefChemistry?.[row.material_id]?.[row.chemical_element_id];
  const edited = original !== undefined && row[field] !== original[field];
  const displayValue = formatNumber(row[field]);
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
      }}
    >
      {scrapchefChemistry !== undefined && row[field] !== scrapchef?.[field] ? (
        <MarkerDot
          corner="top-left"
          color="secondary.main"
          tooltip={
            <>
              <Typography variant="caption" display="block">
                {t("current")}: {displayValue}
              </Typography>
              <Typography variant="caption" display="block">
                {t("scrapchefDefault")}:{" "}
                {scrapchef ? formatNumber(scrapchef[field]) : "—"}
              </Typography>
            </>
          }
        />
      ) : null}
      {field === "loc" && warning ? (
        <MarkerDot
          corner="bottom-left"
          color="error.main"
          label={t("impossibleCombination")}
          tooltip={warning}
        />
      ) : null}
      <Tooltip
        title={
          edited
            ? `${t("savedMeasurement")}: ${formatNumber(original[field])}`
            : ""
        }
      >
        <Typography
          variant="body1Mono"
          sx={{ width: "100%", textAlign: "right", px: 1 }}
        >
          {displayValue}
        </Typography>
      </Tooltip>
    </Box>
  );
};
